import AttachmentPreviewMethod from '../schema/AttachmentPreviewMethod';
export default function createAttachmentViewState(attachmentId, isReadOnly, isCloudy, isPlaceholderAttachment, parentItemId) {
    if (parentItemId === void 0) { parentItemId = null; }
    var viewState = {
        attachmentId: attachmentId,
        thumbnailLoadState: 0 /* NotLoaded */,
        previewLoaded: false,
        isCloudy: isCloudy,
        isReadOnly: isReadOnly,
        isPlaceholderAttachment: isPlaceholderAttachment,
        strategy: {
            allowEdit: false,
            previewMethod: AttachmentPreviewMethod.Unsupported,
            supportedOpenActions: [],
        },
        parentItemId: parentItemId,
    };
    return viewState;
}
//# sourceMappingURL=createAttachmentViewState.js.map